import styled from 'styled-components';

export const InfoBlockContent = styled.div`
  color: var(--color-text);

  .pencil {
    cursor: pointer;

    :hover {
      color: var(--color-text-muted);
    }
  }
`;
